import { Product } from '@bighealth/types';
import { APIRequestBody, APIResponse } from '../../types';
import { api } from '../../api';
import { AxiosRequestConfig } from 'axios';

export const find_with_reference = async (
  args: find_with_reference.Args,
  requestConfig?: AxiosRequestConfig
): Promise<find_with_reference.Response> => {
  const request: find_with_reference.Request = {
    service_name: 'Product',
    service_version: '2',
    service_method: 'find_with_reference',
    args,
  };

  return await api(request, requestConfig);
};

find_with_reference.queryKey = 'Product/find_with_reference';

export declare namespace find_with_reference {
  export type Args = {
    reference: string;
  };

  export interface Request extends APIRequestBody {
    service_name: 'Product';
    service_version: '2';
    service_method: 'find_with_reference';
    args: Args;
  }

  export type Result = Product;

  export type Response = APIResponse<Result>;
}
